import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UserSidebar from '@comp/parts/user-page/UserSidebar.vue';
import UserStatistic from '@comp/parts/user-page/UserStatistic.vue';
import UserFollowers from '@comp/parts/user-page/UserFollowers.vue';
import { profileClient } from '@api/profile';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';
export default {
  name: 'UserPage',
  components: {
    UserSidebar: UserSidebar,
    UserStatistic: UserStatistic,
    UserFollowers: UserFollowers
  },
  props: {
    userName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      sidebar: {
        state: null,
        userPhotoUrl: null,
        userName: null,
        firstName: null,
        lastName: null,
        userNickname: null,
        isPrivate: false,
        onlineStatus: null,
        followers: null,
        job: null,
        university: [],
        location: null,
        descr: null,
        followingTotal: null,
        followingUsers: [],
        folowingUserPage: 1,
        folowingUserPageCount: 6,
        folowingUserHasNextPage: false,
        folowingLoad: true,
        verified: false,
        blockingStatus: null
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters('auth', ['isAuthenticated'])), mapState('userFollowing', {
    usersFollowingState: function usersFollowingState(state) {
      return state.byUserName;
    }
  })), mapState('userBlocking', {
    userBlockingState: function userBlockingState(state) {
      return state.byUserName;
    }
  })), {}, {
    followingStatus: function followingStatus() {
      return (this.usersFollowingState[this.sidebar.userNick] || {}).status || this.sidebar.followingStatus;
    },
    blockingStatus: function blockingStatus() {
      return (this.userBlockingState[this.sidebar.userNick] || {}).status || this.sidebar.blockingStatus;
    },
    followLoading: function followLoading() {
      return !!(this.usersFollowingState[this.sidebar.userNick] || {}).loading;
    },
    blockLoading: function blockLoading() {
      return !!(this.userBlockingState[this.sidebar.userNick] || {}).loading;
    }
  }),
  watch: {
    userName: function userName() {
      this.fetchData();
    },
    usersFollowingState: {
      deep: true,
      handler: function handler(v) {
        if (this.followingStatus !== 'you') return;
        var reload = !Object.values(v).some(function (x) {
          return x.loading;
        });

        if (reload) {
          this.fetchFollowing(this.sidebar.folowingUserPage);
        }
      }
    },
    isAuthenticated: function isAuthenticated() {
      this.fetchData();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('userFollowing', ['follow', 'unfollow'])), {}, {
    fetchFollowing: function fetchFollowing(nextPage) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pageSize, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.sidebar.folowingLoad = true;
                _this.sidebar.folowingUserPage = nextPage;
                pageSize = _this.sidebar.folowingUserPageCount;
                _context.next = 5;
                return profileClient.following(_this.userName, 'popular', nextPage, pageSize);

              case 5:
                resp = _context.sent;

                if (!(_this.sidebar.folowingUserPage !== nextPage)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                _this.sidebar.followingTotal = resp.totalCount;
                _this.sidebar.followingUsers = resp.users.map(function (z) {
                  return {
                    userPhotoUrl: z.photoUrl,
                    userName: "".concat(z.firstName || '', " ").concat(z.lastName || '').trim(),
                    firstName: z.firstName,
                    lastName: z.lastName,
                    userCode: z.userName,
                    statistics: z.statistics,
                    followingStatus: z.followingStatus,
                    leaderBoardPosition: z.leaderBoardPosition,
                    hotBoardPosition: z.hotBoardPosition
                  };
                });
                _this.sidebar.folowingUserHasNextPage = resp.hasNextPage;
                _this.sidebar.folowingLoad = false;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    fetchData: function fetchData() {
      var _this2 = this;

      Promise.all([profileClient.preview(this.userName), profileClient.following(this.userName, 'popular', this.sidebar.folowingUserPage, this.sidebar.folowingUserPageCount)]).then(function (resp) {
        var previewData = resp[0];
        var followingData = resp[1];
        var lastSeen = new Date() - new Date(previewData.lastSeen) < 5 * 60 * 1000 ? 'online' : moment(previewData.lastSeen).fromNow();
        _this2.sidebar = _objectSpread(_objectSpread({}, _this2.sidebar), {}, {
          followingStatus: previewData.followingStatus,
          userPhotoUrl: previewData.imageUrl,
          userName: "".concat(previewData.firstName || '', " ").concat(previewData.lastName || '').trim(),
          firstName: previewData.firstName,
          lastName: previewData.lastName,
          userNickname: "@".concat(previewData.userName),
          userNick: previewData.userName,
          isPrivate: previewData.isPrivate,
          onlineStatus: lastSeen,
          followers: previewData.followers ? {
            number: previewData.followers,
            number_link: '#',
            mutual: previewData.mutualFollowers
          } : null,
          job: previewData.position || previewData.job ? {
            position: previewData.position,
            place: previewData.job,
            place_link: '#'
          } : null,
          university: (previewData.universities || []).map(function (z) {
            return {
              position: 'temp_position',
              place: z.title,
              place_link: '#'
            };
          }),
          location: previewData.address ? {
            place: previewData.address,
            place_link: '#'
          } : null,
          descr: previewData.bio,
          followingTotal: followingData.totalCount,
          followingUsers: followingData.users.map(function (z) {
            return {
              userPhotoUrl: z.photoUrl,
              userName: "".concat(z.firstName || '', " ").concat(z.lastName || '').trim(),
              firstName: z.firstName,
              lastName: z.lastName,
              userCode: z.userName,
              statistics: z.statistics,
              followingStatus: z.followingStatus,
              leaderBoardPosition: z.leaderBoardPosition,
              hotBoardPosition: z.hotBoardPosition
            };
          }),
          folowingUserHasNextPage: followingData.hasNextPage,
          folowingLoad: false,
          userStatistics: previewData.statistics,
          leaderBoardPosition: previewData.leaderBoardPosition,
          hotBoardPosition: previewData.hotBoardPosition,
          verified: previewData.verified,
          blockingStatus: previewData.blockingStatus
        });
      });
    }
  }),
  mounted: function mounted() {
    // check size
    var innerWidth = window.innerWidth;

    if (innerWidth < 1200) {
      this.sidebar.folowingUserPageCount = 6;
    } else if (innerWidth <= 1600) {
      this.sidebar.folowingUserPageCount = 4;
    }

    this.fetchData();
  }
};